module.exports = __webpack_public_path__ + "img/unsub.6cb2dc7c.svg";